import * as plans from '../../../InsuranceForm/plans';
import { createSelector } from 'reselect';
import { carrierSelector } from '../carrier';

const plansSelector = createSelector(
    state => state,
    carrierSelector,
    (state, carrierId) => plans.plansSelector(state, carrierId)
);

export default plansSelector;
